module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tops":"Best data","competition":"Competition"},"fr":{"tops":"Meilleurs classements","competition":"Concurrence"},"de":{"tops":"Top-Rankings","competition":"Übereinstimmung"}}')
  delete Component.options._Ctor
}
